import { COST_TYPE_META } from './useRecipeState'

const ACTION_META = {
  exclude_component: { label: 'Exclude', chipClass: 'chip-danger' },
  include_component: { label: 'Include', chipClass: 'chip-ok' },
  multiply_qty: { label: 'Scale', chipClass: 'chip-accent' },
  add_component: { label: 'Add', chipClass: 'chip-info' },
  formula_qty: { label: 'Compute', chipClass: 'chip-info' },
  set_material: { label: 'Set Material', chipClass: 'chip-accent' },
  set_production_rate: { label: 'Set Rate', chipClass: 'chip-accent' },
  set_class_production_rate: { label: 'Set Class Rate', chipClass: 'chip-accent' },
  include_child_recipe: { label: 'Include Recipe', chipClass: 'chip-ok' },
  exclude_child_recipe: { label: 'Exclude Recipe', chipClass: 'chip-danger' }
}

const EffectSentence = ({ effect, onRemove }) => {
  const meta = ACTION_META[effect.action] || ACTION_META.exclude_component
  const targetDesc = effect.targetDescription || effect.value?.description || '?'

  const costType = effect.value?.costType
  const costMeta = costType ? COST_TYPE_META[costType] : null

  return (
    <div className="eff">
      <span className={`chip chip-sm ${meta.chipClass}`}>{meta.label}</span>

      {costMeta && (
        <span className={`chip chip-sm ${costMeta.chipClass}`}>
          {costMeta.label}
        </span>
      )}

      <span className="eff-target">{targetDesc}</span>

      {effect.action === 'multiply_qty' && (
        <>
          <span className="eff-by">by</span>
          <span className="eff-qual">
            {'\u00D7'}{effect.value || '?'}
          </span>
        </>
      )}

      {effect.action === 'formula_qty' && effect.formula && (
        <>
          <span className="eff-by">qty as</span>
          <span className="eff-qual">{effect.formula}</span>
        </>
      )}

      {effect.action === 'add_component' && effect.value && (
        <span className="eff-note">
          {effect.value.laborRole || effect.value.equipmentRole || ''}
        </span>
      )}

      {effect.note && (
        <span className="eff-note">({effect.note})</span>
      )}

      {onRemove && (
        <button
          className="eff-rm"
          onClick={e => { e.stopPropagation(); onRemove() }}
        >{'\u00D7'}</button>
      )}
    </div>
  )
}

export default EffectSentence
